<template>
  <div class="corp-profit-edit">
    <template-form
      :isBack="true"
      title="แก้ไขข้อมูล"
      description="แก้ไขรายได้และต้นทุนต่อเดือน"
    >
      <div class="cpb-answer">
        {{ labelIncome }}
        <currency v-model="onlineSelling" v-on:change="setOnlineSelling" />
      </div>
      <div class="cpb-answer">
        {{ labelCost }}
        <currency v-model="cost" v-on:change="setCost" />
      </div>

      <material-button
        class="cpb-button"
        :disabled="!validate"
        @clickButton="goBack"
      >
        ตกลง
      </material-button>
    </template-form>
  </div>
</template>

<script>
export default {
  name: "CorpProfitEdit",
  data() {
    const onlineSelling = this.$store.getters["taxInfo/getIncome"]
      .onlineSelling;
    const cost = this.$store.getters["taxInfo/getExpense"].cost;
    const labelIncome = "รายได้จากการขายสินค้าต่อเดือน (ไม่รวม VAT)";
    const labelCost = "ต้นทุนสินค้าต่อเดือน (รวม VAT)";

    return {
      onlineSelling,
      cost,
      labelIncome: labelIncome,
      labelCost: labelCost,
    };
  },
  methods: {
    goBack() {
      const hasHistory = window.history.length > 2;
      hasHistory ? this.$router.go(-1) : this.$router.push("/");
    },
    setOnlineSelling(value) {
      this.$store.dispatch("taxInfo/addIncomeValue", {
        name: "onlineSelling",
        value: value,
      });
    },
    setCost(value) {
      this.$store.dispatch("taxInfo/addExpenseValue", {
        name: "cost",
        value: value,
      });
    },
  },
  computed: {
    validate: function () {
      const onlineSelling = this.$store.state.taxInfo.income.onlineSelling;
      const cost = this.$store.state.taxInfo.expense.cost;

      let valid = false;
      if (onlineSelling > 0) {
        if (cost > 0) {
          valid = true;
        }
      }
      return valid;
    },
  },
};
</script>

<style scoped>
.corp-profit-edit {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.cpb-answer {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
  width: 100%;
  max-width: 352px;
  box-sizing: border-box;
}

.cpb-button {
  max-width: 352px;
  margin-top: 16px;
  margin-bottom: 14px;
}
</style>
